module.exports = __webpack_public_path__ + "img/3.43ceb230.jpg";